


















import { editTeacher, getTeacherProfile } from '@/api/redact';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { PageKey } from '@/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProfileFormItem from './ListPage/ProfileFormItem.vue';
import _cloneDeep from 'lodash/cloneDeep';

@Component({ components: { ProfileFormItem } })
export default class Profile extends Vue {
  editingId: string = '';
  dialogData: PageKey[] = [];
  originData: PageKey[] = [];

  get isTeacher() {
    return !!UserModule.jaccountId && UserModule.jaccountType === 'teacher';
  }

  get isSuperadmin() {
    return UserModule.isSuperadmin;
  }
  get isSlideBarOpened() {
    return AppModule.sidebar.opened;
  }

  async mounted() {
    if (!UserModule._id) {
      await UserModule.GetUserInfo();
    }
    getTeacherProfile({ name: UserModule.username, code: UserModule.code }).then(({ data }) => {
      this.originData = data.keys;
      this.dialogData = _cloneDeep(this.originData);
      this.editingId = data._id;
    });
  }

  isTeacherSelf(dialogData: PageKey[]) {
    if (UserModule.jaccountId) {
      const nameKey = dialogData.find((i) => i.pattern === 'name');
      if (nameKey && UserModule.username === nameKey.value) {
        return true;
      }
    }
    return false;
  }

  async submit() {
    // @ts-ignore
    const editors = (this.$refs.profileFormItem as Vue).editors;

    const submitData = this.dialogData.map((key) => {
      if (key.type !== 'html') {
        return {
          pattern: key.pattern,
          value: key.value || '',
        };
      }
      return {
        pattern: key.pattern,
        value: editors[key.pattern].getContents(false),
      };
    });
    try {
      // 编辑数据
      await editTeacher({ id: this.editingId, data: submitData });
      this.$message.success('编辑成功');
      this.originData = _cloneDeep(this.dialogData);
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  async cancel() {
    await this.$confirm('即将离开页面，请确保填写内容均已保存', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    });
    this.dialogData = _cloneDeep(this.originData);
  }

  handleChange(e: { key: string; value: string } | undefined) {
    if (e && e.key) {
      const item = this.dialogData.find((i) => i.pattern === e.key);
      if (item) {
        item.value = e.value;
      }
    }
  }
}
